import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListAccidentMechanisms } from "../../../components/Admin/AccidentMechanisms/ListAccidentMechanisms/ListAccidentMechanisms";
import { useLanguage } from "../../../contexts";
import "./AccidentMechanisms.scss";

export function AccidentMechanisms() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    { menuItem: t("actives"),   render: () => <Tab.Pane attached={false}><ListAccidentMechanisms active={true}  reload={reload} onReload={onReload} /></Tab.Pane> },
    { menuItem: t("inactives"), render: () => <Tab.Pane attached={false}><ListAccidentMechanisms active={false} reload={reload} onReload={onReload} /></Tab.Pane> },
  ];

  return (
    <div className="accident-mechanisms-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="accident-mechanisms-page-header-wrapper">
        <div className="accident-mechanisms-page-header">
          <span className="accident-mechanisms-page-title">{t("accident_mechanisms")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
